import { render, staticRenderFns } from "./MyProjectDetails.vue?vue&type=template&id=ec83ba1c&scoped=true"
import script from "./MyProjectDetails.vue?vue&type=script&lang=ts"
export * from "./MyProjectDetails.vue?vue&type=script&lang=ts"
import style0 from "./MyProjectDetails.vue?vue&type=style&index=0&id=ec83ba1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec83ba1c",
  null
  
)

export default component.exports